import { asyncLoadRouter } from '@router/helper'

const analytics = [
  {
    path: 'analytics',
    component: asyncLoadRouter('manager/machines/Analytics'),
    meta: {
      breadcrumb: (i18n) => [
        {
          text: i18n.t('machine.analytics.title'),
          to: { name: 'manager-machines-analytics' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-machines-analytics',
        component: asyncLoadRouter('manager/machines/analytics/Show'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.show') }] },
      },
    ],
  },
]

export default analytics
